import Vue from 'vue'
import Component from 'vue-class-component'

import {
  SHOW_MAP_CONFIG_KEY,
  SEARCH_CONFIG_KEY,
  FAQ_CONFIG_KEY,
  DOWNLOAD_CONFIG_KEY,
  FILTER_BY_CATEGORY_KEY,
} from '@/constants'
import { LegendPositions } from '@/types'

@Component
export default class NavButtonsMixin extends Vue {
  get buttonConfig () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.navigation.buttonConfig
  }

  get searchSettingsEnabled () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.searchSettings.enabled
  }

  get faqEnabled () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.faq.enabled
  }

  get downloadEnabled () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.download.enabled
  }

  get showMapEnabled () {
    return this.$typedStore.visualisationApp.showMap && this.$typedStore.activeVisualisation.displaysTreeData
  }

  get filterByCategoryIsButton () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.filterByCategory.position === LegendPositions.TOP_RIGHT_BUTTON
  }

  get filterByCategoryEnabled () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.filterByCategory.enable && this.filterByCategoryIsButton
  }

  buttonEnabled (key: string) {
    switch (key) {
      case SEARCH_CONFIG_KEY:
        return this.searchSettingsEnabled
      case FAQ_CONFIG_KEY:
        return this.faqEnabled
      case DOWNLOAD_CONFIG_KEY:
        return this.downloadEnabled
      case SHOW_MAP_CONFIG_KEY:
        return this.showMapEnabled
      case FILTER_BY_CATEGORY_KEY:
        return this.filterByCategoryEnabled
      default:
        return false
    }
  }
}
